export default __webpack_public_path__ + "static/media/my_picks.738751c6.png";